import { render } from "./JuvenilTable.vue?vue&type=template&id=a0f064fe&scoped=true"
import script from "./JuvenilTable.vue?vue&type=script&lang=js"
export * from "./JuvenilTable.vue?vue&type=script&lang=js"

import "./JuvenilTable.vue?vue&type=style&index=0&id=a0f064fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f064fe"]])

export default __exports__